export default "__VITE_ASSET__S_4ZO8CL__"